import { defineAiSystem } from '@evo-flywheel/contracts/base';
/**
 * Sistema AI — the AI Registry. One entry per governed AI solution.
 * The heart of the portal: every other document either feeds into or reads from this.
 * Source: Marko spec §1. coreBOS-A module: new (registry pattern, anagrafica+owner+stato+scadenze).
 *
 * The vocabulary (registry fields + AI Act block) is the contracts base, shared with the
 * compliance kit (governance ADR-006, ADR-030 §4). Only what is this kit's own is declared here.
 *
 * `stato_approvazione` is calcolato — driven by the linked Richiesta AI workflow outcome.
 * `ultima_interazione` / `contatore_utilizzo` are calcolato — projection from ai_interaction store.
 * Governance admin can manually set Dismesso at end of life.
 */
export const aiSystemDescriptor = defineAiSystem({
    table: 'ai_portal_ai_system',
    fields: [
        { name: 'ultima_interazione', type: 'date', label: 'Ultima interazione' }, // calcolato
        { name: 'contatore_utilizzo', type: 'number', label: 'Contatore utilizzo' }, // calcolato
    ],
    relations: [
        { name: 'owner_interno', kind: 'belongsTo', target: 'ai_user' },
        { name: 'richiesta_origine', kind: 'belongsTo', target: 'ai_request' },
    ],
    emits: ['ai_system.created', 'ai_system.approved', 'ai_system.dismissed', 'ai_system.updated'],
    ui: { mode: 'generated', icon: 'SafetyOutlined', navGroup: 'Governance', navOrder: 1 },
});
